import React, { useState } from 'react';
import styles from 'sections/works/works.module.css';
import {
    getDesktopSrc2x,
    getDesktopSrc3x,
    getDesktopSrcWebp,
    getDesktopSrcWebp2x,
    getDesktopSrcWebp3x,
    getMobileSrc,
    getMobileSrc2x,
    getMobileSrc3x,
    getMobileSrcWebp,
    getMobileSrcWebp2x,
    getMobileSrcWebp3x,
} from 'utils/imageResize.utils';

interface IWorksItemImage {
    imageUrl?: string;
    title: string;
}

export const WorksItemImage = ({ imageUrl, title }: IWorksItemImage) => {
    const desktopSrcWebp = getDesktopSrcWebp(imageUrl);
    const desktopSrcWebp2x = getDesktopSrcWebp2x(desktopSrcWebp);
    const desktopSrcWebp3x = getDesktopSrcWebp3x(desktopSrcWebp);

    const desktopSrc2x = getDesktopSrc2x(imageUrl);
    const desktopSrc3x = getDesktopSrc3x(imageUrl);

    const mobileSrc = getMobileSrc(imageUrl);

    const mobileSrc2x = getMobileSrc2x(mobileSrc);
    const mobileSrc3x = getMobileSrc3x(mobileSrc);

    const mobileSrcWebp = getMobileSrcWebp(mobileSrc);
    const mobileSrcWebp2x = getMobileSrcWebp2x(mobileSrcWebp);
    const mobileSrcWebp3x = getMobileSrcWebp3x(mobileSrcWebp);

    const [isImgLoaded, setIsImgLoaded] = useState(false);
    const handleImageLoad = () => {
        setIsImgLoaded(true);
    };

    return (
        <>
            {!isImgLoaded && <div className={styles.item__imgLoading}></div>}
            <div className={styles.item__imgAnimated}>
                <picture>
                    <source
                        type="image/webp"
                        media="(max-width: 600px)"
                        srcSet={`${mobileSrcWebp} 1x, ${mobileSrcWebp2x} 2x, ${mobileSrcWebp3x} 3x`}
                        sizes="(max-width: 600px) 100vw"
                    />
                    <source
                        type="image/png"
                        media="(max-width: 600px)"
                        srcSet={`${mobileSrc} 1x,  
                            ${mobileSrc2x} 2x, 
                            ${mobileSrc3x} 3x`}
                        sizes="(max-width: 600px) 100vw"
                    />

                    <source
                        type="image/webp"
                        srcSet={`${desktopSrcWebp} 1x, ${desktopSrcWebp2x} 2x, ${desktopSrcWebp3x} 3x`}
                        sizes="100vw"
                    />

                    <img
                        src={imageUrl}
                        srcSet={`${desktopSrc2x} 2x, ${desktopSrc3x} 3x`}
                        sizes="100vw"
                        loading="lazy"
                        alt={title}
                        width="100%"
                        height="auto"
                        onLoad={handleImageLoad}
                    />
                </picture>
            </div>
        </>
    );
};
